module.exports = __webpack_public_path__ + "static/img/champ-banner-event-detail.205fc93.jpg";